import { IImageSettings, IViewPort } from '@msdyn365-commerce/core';

export function convertImageSettingsToWebp(imageSettings?: IImageSettings): IImageSettings | undefined {
    if (!imageSettings?.viewports) {
        return imageSettings;
    }

    const updatedViewports = Object.fromEntries(
        Object.entries(imageSettings.viewports).map(([key, value]) => {
            if (value && value.q && value.q.includes('f=webp')) {
                return [key, value];
            }
            const url = new URLSearchParams(value.q);
            url.set('f', 'webp');
            return [key, { ...value, q: url.toString() }];
        })
    ) as IViewPort;

    return {
        ...imageSettings,
        viewports: updatedViewports
    };
}
